import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { logoutUser, verifyStoredAuthSession } from "../controllers/authController";

export default function useAuthController() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  // 🔐 Auto-check authentication
  useEffect(() => {
    let active = true;

    const run = async () => {
      const verifiedUser = await verifyStoredAuthSession();

      if (!active) return;

      if (!verifiedUser) {
        await logoutUser();
        navigate("/", {
          replace: true,
          state: { message: "Your session expired. Please log in again." },
        });
        return;
      }

      setUser(verifiedUser);
      setLoading(false);
    };

    run();

    return () => {
      active = false;
    };
  }, [navigate]);

  // 🚪 Logout handler
  const handleLogout = async () => {
    try { await logoutUser(); navigate("/"); }
    catch (error) { window.alert(error.message); }
  };

  return { user, loading, handleLogout };
}
